<script lang="ts" setup>
import TypeTool from "@/utils/TypeTool";


const contentRef = ref<HTMLDivElement>();
const badgeRef = ref<HTMLSpanElement>();

defineProps<{
    value: any,
}>();

const resizeObserver = new ResizeObserver(() => updateBadgePosition());

onMounted(() => {
    resizeObserver.observe(contentRef.value!);
    resizeObserver.observe(badgeRef.value!);
});

onBeforeUnmount(() => {
    resizeObserver.unobserve(contentRef.value!);
    resizeObserver.unobserve(badgeRef.value!);
});

function updateBadgePosition() {
    const crw = contentRef.value?.scrollWidth;
    const brw = badgeRef.value?.scrollWidth;
    console.log(`contentRef = ${crw},badgeRef = ${brw}`);
    if (crw != null && brw != null) {
        const base = crw / 2;
        const remain = crw - base;
        console.log(`contentRef = ${crw},badgeRef = ${brw} diff = ${crw / 2 - brw}`);
        if (remain < brw) {
            badgeRef.value!.style.left = `${base - brw + remain}px`;
        } else {
            badgeRef.value!.style.left = `${base}px`;
        }
    }
}
</script>
<template>
    <div ref="badgeContainerRef" class="lm-badge">
        <div ref="contentRef">
            <slot>
            </slot>
        </div>
        <span ref="badgeRef" :class="{'badge':true,'invisible':TypeTool.isEmtpy(value)}">{{ value }}</span>
    </div>
</template>
<style lang="scss" scoped>
    .lm-badge {
        display: inline-flex;
        position: relative;
        margin-left: 16px;

        .badge {
            background: linear-gradient(180deg, #FF7171 0%, #FF0000 100%);
            border-radius: 12px 12px 12px 0px;
            border: 1px solid #FFFFFF;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 20px;
            padding: 0px 4px;
            position: absolute;
            height: min-content;
            top: 0px;
            top: -14px;
            left: 50%;
            width: max-content;
        }
        .invisible{
            display: none;
        }
    }
</style>